import React from "react";

const ContactDirectoryBlock = (): JSX.Element => {
  return (
    <>
    <div className="content_card section">
      <div className="col-md-12 img" />
      <div className="col-md-12 info-text">
        <div className="contenttype_area" />
        <h2 className="heading-4">
          Contact Directory
        </h2>
        <span className="manual">
          Search the Dun &amp; Bradstreet Data Cloud, covering hundreds of millions of records to discover insights about contacts of interest to you.
        </span>
      </div>
    </div>
    </>
  )
}

export default ContactDirectoryBlock;